import FileModel from './globals/FileModel';

export default class StandDocumentsZipModel extends FileModel {
  static get path() {
    return '/backend/stands/documents/zip';
  }
}
